import React, { Suspense, useEffect } from 'react'
import { useGateValue } from '@statsig/react-bindings'
import { Switch, Route, useLocation } from 'react-router-dom'
import Screens from '../Components/Screens/Scenes'
import analytics from '../../../../shared/services/analytics'
import { useAuth } from '../../../../auth/Auth.hook'

const ViewChangePassword = React.lazy(() =>
  import('../../../../refactory/modules/auth/infrastructure/change-password/ChangePassword')
)

const RouteScene = (props) => {
  const isNewRejectItemsPostDeliveryActive = useGateValue('is_new_reject_items_active')
  const location = useLocation()
  const { userInfo } = useAuth()

  useEffect(() => {
    if (userInfo) {
      analytics.setUserProperties(userInfo.user.email, userInfo.client.name)
    }
  }, [userInfo])

  useEffect(() => {
    analytics.pageView(location.pathname + location.search)
  }, [location])
  return (
    <React.Fragment>
      <Switch>
        <Route exact path='/orders' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/resources/:resourceId' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/:jobId' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/:jobId/resources/:resourceIdDetail' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/:jobId/invoices' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/:jobId/cancel' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/:jobId/issue' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/:jobId/change-store' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/:jobId/reschedule' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/:jobId/re-assign' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/:jobId/items' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/:jobId/items/add' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/:jobId/items/print' render={() => <Screens {...props} view='orders' />} />

        <Route exact path='/orders/map' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/map/resources/:resourceId' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/map/:jobId' render={() => <Screens {...props} view='orders' />} />
        <Route
          path='/orders/map/:jobId/resources/:resourceIdDetail'
          render={() => <Screens {...props} view='orders' />}
        />
        <Route exact path='/orders/map/:jobId/invoices' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/map/:jobId/cancel' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/map/:jobId/issue' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/map/:jobId/change-store' render={() => <Screens {...props} view='orders' />} />
        <Route exact path='/orders/map/:jobId/reschedule' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/map/:jobId/re-assign' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/map/:jobId/items' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/map/:jobId/items/add' render={() => <Screens {...props} view='orders' />} />
        <Route path='/orders/map/:jobId/items/print' render={() => <Screens {...props} view='orders' />} />

        {isNewRejectItemsPostDeliveryActive && (
          <Route
            exact
            path='/orders/:jobId/incidence/create'
            render={() => <Screens {...props} view='order-incidence-create' />}
          />
        )}
        {isNewRejectItemsPostDeliveryActive && (
          <Route
            exact
            path='/orders/:jobId/incidence/resolution'
            render={() => <Screens {...props} view='order-incidence-resolve' />}
          />
        )}

        <Route exact path='/tasks' render={() => <Screens {...props} view='tasks' />} />

        <Route exact path='/alert-management/orders' render={() => <Screens {...props} view='alert-management' />} />
        <Route
          exact
          path='/alert-management/orders/resources/:resourceId'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          exact
          path='/alert-management/orders/:jobId'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          path='/alert-management/orders/:jobId/resources/:resourceIdDetail'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          exact
          path='/alert-management/orders/:jobId/invoices'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          exact
          path='/alert-management/orders/:jobId/cancel'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          exact
          path='/alert-management/orders/:jobId/issue'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          exact
          path='/alert-management/orders/:jobId/change-store'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          exact
          path='/alert-management/orders/:jobId/reschedule'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          path='/alert-management/orders/:jobId/re-assign'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          path='/alert-management/orders/:jobId/items'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          path='/alert-management/orders/:jobId/items/add'
          render={() => <Screens {...props} view='alert-management' />}
        />
        <Route
          path='/alert-management/orders/:jobId/items/print'
          render={() => <Screens {...props} view='alert-management' />}
        />

        <Route exact path='/routes' render={() => <Screens {...props} view='routes' />} />
        <Route exact path='/routes/stores/:storeId' render={() => <Screens {...props} view='routes' />} />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/cancel-route'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/reassign-driver'
          render={() => <Screens {...props} view='routes' />}
        />

        {/* ROOUTES V2 START */}
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/resources/:resourceIdDetail'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/invoices'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/cancel'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/issue'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/change-store'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/reschedule'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/re-assign'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/items'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/items/add'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/routes/:routeId/orders/:jobId/items/print'
          render={() => <Screens {...props} view='routes' />}
        />
        {/* ROOUTES V2 END*/}

        {/* ROOUTES OLD START */}
        <Route exact path='/routes/stores/:storeId/orders/:jobId' render={() => <Screens {...props} view='routes' />} />
        <Route
          path='/routes/stores/:storeId/orders/:jobId/resources/:resourceIdDetail'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/orders/:jobId/invoices'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/orders/:jobId/cancel'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/orders/:jobId/issue'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/orders/:jobId/change-store'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          exact
          path='/routes/stores/:storeId/orders/:jobId/reschedule'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/orders/:jobId/re-assign'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route path='/routes/stores/:storeId/orders/:jobId/items' render={() => <Screens {...props} view='routes' />} />
        <Route
          path='/routes/stores/:storeId/orders/:jobId/items/add'
          render={() => <Screens {...props} view='routes' />}
        />
        <Route
          path='/routes/stores/:storeId/orders/:jobId/items/print'
          render={() => <Screens {...props} view='routes' />}
        />
        {/* ROOUTES OLD END*/}

        <Route path='/routes/create/:storeId' render={() => <Screens {...props} view='routes' />} />
        <Route path='/routes/create' render={() => <Screens {...props} view='routes' />} />
        <Route exact path='/routes/*' render={() => <Screens {...props} view='routes' />} />
        <Route exact path='/metrics/order-status' render={() => <Screens {...props} view='metrics' />} />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slot-from/:slotStartTime'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/resources/:resourceId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/resources/:resourceIdDetail'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/invoices'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/cancel'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/issue'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/change-store'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/reschedule'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/re-assign'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/items'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/items/add'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/order-status/:orderStatus/slots/:orderHour/orders/:jobId/items/print'
          render={() => <Screens {...props} view='metrics' />}
        />

        <Route exact path='/metrics/store-capacity' render={() => <Screens {...props} view='metrics' />} />
        <Route exact path='/metrics/store-capacity/slot-status' render={() => <Screens {...props} view='metrics' />} />
        <Route
          exact
          path='/metrics/store-capacity/fleet-capacity'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/store-capacity/fleet-capacity/fleets/:fleetId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route exact path='/metrics/store-status' render={() => <Screens {...props} view='metrics' />} />
        <Route exact path='/metrics/live-support' render={() => <Screens {...props} view='metrics' />} />
        <Route exact path='/metrics/live-support/orders/:jobId' render={() => <Screens {...props} view='metrics' />} />
        <Route
          path='/metrics/live-support/orders/:jobId/resources/:resourceIdDetail'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/live-support/orders/:jobId/invoices'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/live-support/orders/:jobId/cancel'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/live-support/orders/:jobId/issue'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/live-support/orders/:jobId/change-store'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/live-support/orders/:jobId/reschedule'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          path='/metrics/live-support/orders/:jobId/re-assign'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route path='/metrics/live-support/orders/:jobId/items' render={() => <Screens {...props} view='metrics' />} />
        <Route
          path='/metrics/live-support/orders/:jobId/items/add'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          path='/metrics/live-support/orders/:jobId/items/print'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route exact path='/metrics/resource-status' render={() => <Screens {...props} view='metrics' />} />
        <Route
          exact
          path='/metrics/resource-status/users/:userId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resource-status/users/:userId/profile'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route exact path='/metrics/resources' render={() => <Screens {...props} view='metrics' />} />
        <Route exact path='/metrics/resources/pickers' render={() => <Screens {...props} view='metrics' />} />
        <Route
          exact
          path='/metrics/resources/pickers/resource/:resourceId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resources/pickers/resource/:resourceId/*'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resources/pickers/order/:jobId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resources/pickers/order/:jobId/*'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route exact path='/metrics/resources/driver-status' render={() => <Screens {...props} view='metrics' />} />
        <Route
          exact
          path='/metrics/resources/driver-status/resource/:resourceId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resources/driver-status/resource/:resourceId/*'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resources/driver-status/order/:jobId'
          render={() => <Screens {...props} view='metrics' />}
        />
        <Route
          exact
          path='/metrics/resources/driver-status/order/:jobId/*'
          render={() => <Screens {...props} view='metrics' />}
        />

        <Route exact path='/resources/massive-quotas' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/stores' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/stores/:storeId' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/stores/create' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/fleets' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/fleets/:fleetId' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/vehicles' render={() => <Screens {...props} view='resources' />} />

        <Route
          exact
          path='/resources/fleets/:fleetId/edit-quota'
          render={() => <Screens {...props} view='resources' />}
        />
        <Route exact path='/resources/fleets/create' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/users' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/users/:userId' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/users/:userId/profile' render={() => <Screens {...props} view='resources' />} />
        <Route exact path='/resources/users/:userId/profile/*' render={() => <Screens {...props} view='resources' />} />
        <Route
          exact
          path='/resources/users/:userId/remove-capacity'
          render={() => <Screens {...props} view='resources' />}
        />
        <Route
          exact
          path='/resources/users/:userId/add-capacity'
          render={() => <Screens {...props} view='resources' />}
        />
        <Route exact path='/resources/users/create' render={() => <Screens {...props} view='resources' />} />

        <Route exact path='/system-parameters/general' render={() => <Screens {...props} view='system-parameters' />} />
        <Route
          exact
          path='/system-parameters/general/:generalParameterId'
          render={() => <Screens {...props} view='system-parameters' />}
        />
        <Route exact path='/system-parameters/flags' render={() => <Screens {...props} view='system-parameters' />} />
        <Route
          exact
          path='/system-parameters/flags/:flagParameterId'
          render={() => <Screens {...props} view='system-parameters' />}
        />
        <Route
          exact
          path='/system-parameters/logistics/:logisticParameterId'
          render={() => <Screens {...props} view='system-parameters' />}
        />
        <Route exact path='/system-parameters/reasons' render={() => <Screens {...props} view='system-parameters' />} />
        <Route
          exact
          path='/system-parameters/logistics'
          render={() => <Screens {...props} view='system-parameters' />}
        />

        <Route exact path='/user-management/users' render={() => <Screens {...props} view='users' />} />
        <Route exact path='/user-management/users/create' render={() => <Screens {...props} view='users' />} />
        <Route exact path='/user-management/users/:userId' render={() => <Screens {...props} view='users' />} />
        <Route exact path='/user-management/groups' render={() => <Screens {...props} view='users' />} />
        <Route exact path='/user-management/groups/create' render={() => <Screens {...props} view='users' />} />
        <Route exact path='/user-management/groups/:groupId' render={() => <Screens {...props} view='users' />} />
        <Route
          exact
          path='/user-management/roles/:roleId/permissions'
          render={() => <Screens {...props} view='users' />}
        />
        <Route exact path='/user-management/roles' render={() => <Screens {...props} view='users' />} />
        <Route path='/accounting' render={() => <Screens {...props} view='accounting' />} />
        <Route path='/ecommerceAdmin' render={() => <Screens {...props} view='ecommerceAdmin' />} />
        <Route path='/inbox' render={() => <Screens {...props} view='inbox' />} />
        <Route path='/wms' render={() => <Screens {...props} view='wms' />} />
        <Route path='/segmenter' render={() => <Screens {...props} view='segmenter' />} />
        <Route path='/comanda' render={() => <Screens {...props} view='comanda' />} />
        <Route path='/jonah-jameson' render={() => <Screens {...props} view='jonah-jameson' />} />
        <Route path='/leapdocs' render={() => <Screens {...props} view='leapdocs' />} />
        <Route exact path='/activity-log' render={() => <Screens {...props} view='activity-log' />} />
        <Route exact path='/analytics' render={() => <Screens {...props} view='analytics' />} />
        <Route exact path='/analytics/resource-status' render={() => <Screens {...props} view='analytics' />} />
        <Route exact path='/analytics/out-of-stock' render={() => <Screens {...props} view='analytics' />} />
        <Route exact path='/analytics/picker-productivity' render={() => <Screens {...props} view='analytics' />} />
        <Route exact path='/analytics/driver-productivity' render={() => <Screens {...props} view='analytics' />} />
        <Route path='/order-ratings' render={() => <Screens {...props} view='order-ratings' />} />
        <Route
          exact
          path='/system-parameters/picking-route'
          render={() => <Screens {...props} view='system-parameters' />}
        />
        <Route
          exact
          path='/system-parameters/slot-policies'
          render={() => <Screens {...props} view='system-parameters' />}
        />
        <Route
          exact
          path='/system-parameters/api-credentials'
          render={() => <Screens {...props} view='system-parameters' />}
        />
        <Route path='/reports' render={() => <Screens {...props} view='reports' />} />
        <Route path='/not-found' render={() => <Screens {...props} view='not-found' />} />
        <Route
          path='/change-password'
          render={() => (
            <Suspense fallback={<></>}>
              <ViewChangePassword />
            </Suspense>
          )}
        />
        <Route
          path='/marketplace-manager/:storeId/marketplaces'
          render={() => <Screens {...props} view='marketplace-manager' />}
        />
        <Route path='/marketplace-manager' render={() => <Screens {...props} view='marketplace-manager' />} />
        <Route path='/call-center' render={() => <Screens {...props} view='call-center' />} />
        <Route path='*' render={() => <Screens {...props} view='orders' />} />
      </Switch>
    </React.Fragment>
  )
}

export default RouteScene
